<div class="row" style="margin-top: 20px;">
  <div class="col-md-2">
    <app-gateway-left-panel></app-gateway-left-panel>
  </div>
  <div class="col-md-10">
    <router-outlet></router-outlet>
  </div>
</div>
